<template>
  <div class="goods-container">
    <component :is="goodsComponent"/>
  </div>
</template>
  
  <script>
  import goodsType1 from './goods--type1/index.vue';
  import goodsType2 from './goods--type2/index.vue';
  
  export default {
	name: 'HomePage',
	components: {
	  goodsType1,
	  goodsType2
	},
	data() {
	  return {
		state: {
		  type: sessionStorage.getItem('templateId'), // 从接口/路由获取
		},
	  };
	},
  
	computed: {
	  goodsComponent() {
		const map = {
		  100: goodsType1,
		  101: goodsType1,
		  102: goodsType1,
		  103: goodsType1,
		  104: goodsType2,
		};
		return map[this.state.type];
	  },
	},
  };
  </script>
